import { GetStaticProps } from "next"
import React from "react"
import Body from "../../components/body/body"
import PostPreview from "../../components/postPreview/postPreview"
import { Grid } from "../../styles/posts_style"

const Posts = ({ posts }) => {
	return (
		<Body subtitle="Blog" subtitleLink="/blog">
			<Grid>
				{posts &&
					posts.map(({ node }, index) => (
						<PostPreview
							key={node.slug}
							title={node.title}
							slug={node.slug}
							author={node.author.node.name}
							date={node.date}
							excerpt={node.excerpt}
							featuredImage={node.featuredImage}
							style={{
								gridColumn: `span ${index === 0 ? 2 : 1}`,
							}}
						/>
					))}
			</Grid>
		</Body>
	)
}

export default Posts

export const getStaticProps: GetStaticProps = async () => {
	// const posts = await getAllPostsForHome()

	const fetchedPosts = [
		{
			node: {
				title: "How to set up your Space",
				excerpt:
					"<p>How to setup your personal SaySom Space To create your personal SaySom event, you must first register on SaySom. After your registration, you can create your own free Space.&nbsp; Creating a Space is still as simple as it could be, just hit the &#8220;Create Space&#8221; button on our website, give your Space a logo and [&hellip;]</p>\n",
				slug: "how-to-set-up-your-space",
				date: "2021-07-28T12:26:01",
				featuredImage: {
					node: {
						sourceUrl:
							"https://blog.saysom.app/wp-content/uploads/2021/07/Pharma.png",
					},
				},
				author: {
					node: {
						name: "Antonia Pervanidis",
						firstName: "Antonia",
						lastName: "Pervanidis",
						avatar: {
							url:
								"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
						},
					},
				},
			},
		},
		{
			node: {
				title: "How to use SaySom",
				excerpt:
					"<p>Let’s bring people back together. Preperation Use SaySom in Chrome &#8211; trust me it, works best Make sure you don&#8217;t use your camera and microphone for any other system, or we won&#8217;t be able to access them. It&#8217;s best to leave third-party systems like Zoom or Microsoft Teams in advance. If possible, turn off your [&hellip;]</p>\n",
				slug: "how-to-use-saysom",
				date: "2021-06-15T13:58:01",
				featuredImage: {
					node: {
						sourceUrl:
							"https://blog.saysom.app/wp-content/uploads/2021/06/Gründermotor.png",
					},
				},
				author: {
					node: {
						name: "Antonia Pervanidis",
						firstName: "Antonia",
						lastName: "Pervanidis",
						avatar: {
							url:
								"https://secure.gravatar.com/avatar/d93647adf8f6f3c902c99a31ec36c23b?s=96&d=mm&r=g",
						},
					},
				},
			},
		},
	]

	return { props: { posts: fetchedPosts }, revalidate: 1 }
}
